import Colors from "../../Themes/Colors";
import grey from "@material-ui/core/colors/grey";

const useStyles = (theme) => ({
  padding20: {
    padding: 15,
    paddingBottom:0
  },
  padding15: {
    padding: 15
  },
  paddingLeft15: {
    paddingLeft: 15
  },
  paddingTop15: {
    paddingTop: 15
  },

  margin10: {
    marginTop: 10,
    marginBottom: 10
  },
  marginTop5: {
    marginTop: 5
  },
  marginTop20: {
    marginTop: 20
  },

  font15: {
    fontSize: 15
  },

  paper: {
    marginTop: 5,
    padding: 10
  },

  input: {
    borderColor: grey[400]
  },

  timeSlotsGrid: {
    marginTop: 10,
    textAlign: "center"
  },

  centerLoading: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -50,
    marginLeft: -50,
    width: 100,
    height: 100
  },

  centerContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  container: {
    height: "100%",
    width: "100%"
  },

  loadingStyle: {
    color: Colors.primary,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  title: {
    color: "#1A237E",
    fontSize: 20,
    fontWeight: 600
  },
  heading1: {
    fontSize: 15,
    marginTop: 10,
  },
  textFieldName: {
    fontSize :14,
    transform: "translate(14px, 10px) scale(1)",
  },
  inputField: {
    height:34,
    borderRadius:0,
  },
  autoCompleteBorder:{
  
      [`& fieldset`]: {
        borderRadius: 0,
      },
  
  },
  
  slotButton: {
    padding: "3px 6px",
    minWidth: "auto",
    borderRadius: 3,
    [theme.breakpoints.down('sm')]:{
      padding:3,
    }
  },
  slotDayHeader: {
    padding: 3,
    borderRadius: 3
  },
  mainLayout: {
    display:"flex",
    flexDirection:"column",
    alignItems: "center",
    justifyContent: "center"
  },
  mainPanelGrid : {
    padding: "15px"
  },
  cardpanel: {
    justifyContent:"center",
    alignItems:"center"
  },
  cardHeader : {
    display: "flex",
    alignItems:"center",
    justifyContent:"space-between"
  },
  numberCircle : {
    width:"32px",
    backgroundColor: "#313131",
    borderRadius:"50%",
    color:"#ffffff",
    fontFamily:"sans-serif", 
    textAlign:"center",
    lineHeight:"32px",
    marginRight:"30px"
  },
  cardTitle:{
    color:"inherit",
    fontFamily:"sans-serif", 
  },
  titleCommon : {
    display: "flex",
    alignItems:"center",
    justifyContent:"space-between"
  },
  itemPanelGrid : {
    alignItems:"center",
    display:"flex",
  },
  itemPanelCard : {
    boxShadow:"none",
    border:"transparent",
    textAlign:"center",
    width:"100%",
	height:"100%",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    "&:hover": {
      borderColor: "black"
    }
  },
  containerPanel : {
    backgroundColor: "#fff",
    padding: "15px 30px",
    border: "1px solid #dfdfdf",
    marginTop: "15px",
  },
  contentHover:{
    background:"none",
    borderRadius: 4.5,
    padding: "7.5px 15px",
    display:"inline-table",
    width:"75%",
    height:"100%",
  },
  subtitleAlign : {
    width:"200px",
    overflow:"hidden",
    whiteSpace:"nowrap",
    textOverflow:"ellipsis"
  },
  textField : {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  sticky : {
    background:"none",
    border:"none",
    padding:15,
    textAlign:"center",
    position:"fixed",
    top:0,
    zIndex:2,
  },
  confirmHeader:{
    fontSize:16,
    color:"#444",
    fontWeight:"bold",
  },
  confirmationCart:{
    width:"50%",
    transform: "translate(50%,0)",
  },
  formControl: {
    margin: theme.spacing(1),
  },
  noData: {
    display:"flex",
    justifyContent: "center",
  },
  activeColor: { 
    backgroundColor: "blue",
  }
});

export default useStyles;
